import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { closeParticipantModel, exportPollParticipants } from "../../store/slices/pollSlice";
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';
import PersonIcon from '@mui/icons-material/Person';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import FacebookIcon from '@mui/icons-material/Facebook';
import EmailIcon from '@mui/icons-material/Email';
import { getEventSubList } from "../../store/slices/eventSlice";


const getModalContent = () => {
   
            return (
                <>
                    <svg viewBox="0 0 24 24" className="status-icon">
                        <circle cx="12" cy="12" r="12" fill="#4A90E2"></circle>
                        <path
                            fill="white"
                            d="M4.5 6.6h6.9v2.9H4.5V6.6zm0 7.4h14.8v-3H4.5v3zm0 4.4h10.8v-2.9H4.5v2.9z"
                        ></path>
                    </svg>
                    <div className="px-4 h4 mb-0">Event Followers</div>
                </>
            );
};

const EventSubscriberModel = ({ show}) => {
    const dispatch = useDispatch();
    const { eventId } = useSelector((state) => state.event);
    const [isLoading, setIsLoading] = useState(false);
    const [participants, setParticipants] = useState([]);
    const [open, setOpen] = useState('');

    const toggle = (id) => {
        setOpen(open === id ? '' : id);
    };

    const hideModel = () => dispatch(closeParticipantModel());

    useEffect(() => {
        if (eventId) {
            setIsLoading(true);
            dispatch(getEventSubList({ id: eventId }))
                .unwrap()
                .then((res) => {
                    setParticipants(res || []);
                    setIsLoading(false);
                })
                .catch(() => setIsLoading(false));
        }
    }, [eventId, dispatch]);


    return (
        <Modal show={show} size="lg" backdrop="static" keyboard={false} >
            <div className="status-box p-3">
                {getModalContent()}
            </div>

            <div className="p-3 position-relative" style={{ minHeight: '300px' }}>
                {isLoading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{
                        position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(255, 255, 255, 0.7)", zIndex: 9999
                    }}>
                        <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <Accordion open={open} toggle={toggle}>
                        {participants.map((participant, index) => {
                            const explodedName = participant.name?.split(' ') || [];

                            let initials = `${explodedName[0]?.charAt(0) || ''}${explodedName[1]?.charAt(0) || ''}`.toUpperCase();

                            if (participant.avatar) {
                                initials = <img className="avatar w-100" src={participant.avatar} alt="avatar" />;
                            }

                            const facebookInfo = participant.extraInfo?.facebook;

                            return (
                                <AccordionItem key={index}>
                                    <AccordionHeader targetId={index.toString()} className="custom-header">
                                        <div className="namedLogo rounded-circle overflow-hidden">{initials}</div>
                                        <span className="text-capitalize">
                                            {facebookInfo?.displayName || participant.name || participant.extraInfo.firstName + ' ' + participant.extraInfo.lastName}
                                        </span>

                                    </AccordionHeader>

                                    <AccordionBody accordionId={index.toString()}>
                                        <table className="table mb-0">
                                            <tbody>
                                                {facebookInfo ? (
                                                    <>
                                                        <tr className="border-bottom">
                                                            <td className="text-center" style={{ width: '50px' }}>
                                                                <EmailIcon />
                                                            </td>
                                                            <td>{facebookInfo.email}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-center">
                                                                <FacebookIcon
                                                                    onClick={() => {
                                                                        window.open(`https://www.facebook.com/${facebookInfo.id}`, '_blank');
                                                                    }}
                                                                    style={{ cursor: "pointer", color: "#3B5998" }}
                                                                />
                                                            </td>
                                                            <td>Facebook Profile</td>
                                                        </tr>
                                                    </>
                                                ) : (
                                                    <tr>
                                                        <td className="text-center" style={{ width: '50px' }}>
                                                            <LocalPhoneIcon />
                                                        </td>
                                                        <td>{participant.userId}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </AccordionBody>

                                </AccordionItem>
                            );
                        })}
                    </Accordion>
                )}
            </div>

            <div className="text-right p-3">
                <div className="button-div">
                    <button type="button" className="btn btn-outline-danger mx-3" onClick={hideModel}>
                        Close
                    </button>
                </div>
            </div>
        </Modal >
    );
};

export default EventSubscriberModel;
